export default "__VITE_ASSET__C3F4bQR3__"